/**
 * product.js — VariantSelector and MediaGallery custom elements
 */

/* ── VariantSelector ────────────────────────────────── */
class VariantSelector extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('[data-section-id]');
    this.sectionId = this.section.dataset.sectionId;
    this.variants = JSON.parse(
      document.getElementById(`ProductJson-${this.sectionId}`).textContent
    );
    this.addEventListener('change', this.onOptionChange.bind(this));
  }

  get selectedOptions() {
    return Array.from(this.querySelectorAll('input:checked, select'))
      .map((el) => el.value);
  }

  findVariant(options) {
    return this.variants.find((v) =>
      v.options.every((opt, i) => opt === options[i])
    );
  }

  async onOptionChange() {
    const variant = this.findVariant(this.selectedOptions);
    if (!variant) return;

    const base = this.dataset.url || window.location.pathname + window.location.search;
    const url = new URL(base, window.location.origin);
    url.searchParams.set('variant', variant.id);

    const quickInner = this.closest('[data-quick-view-inner]');
    if (!quickInner) {
      history.replaceState({}, '', url.toString());
    }

    const fetchKey = this.dataset.sectionFetch || this.sectionId;
    const data = await fetchSection(url.pathname + url.search, [fetchKey]);
    const freshHtml = data[fetchKey];

    if (quickInner && freshHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(freshHtml, 'text/html');
      const sectionEl = doc.querySelector('[id^="shopify-section-"]');
      if (sectionEl) {
        quickInner.innerHTML = sectionEl.innerHTML;
      }
      return;
    }

    [`price-${this.sectionId}`, `product-form-${this.sectionId}`].forEach((id) => {
      renderSection(`#${id}`, freshHtml, `#${id}`);
    });
  }
}

customElements.define('variant-selector', VariantSelector);

/* ── MediaGallery ───────────────────────────────────── */
class MediaGallery extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('#ProductMedia-featured');
    this.thumbs = this.querySelectorAll('[data-media-thumb]');

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.onThumbClick(thumb));
    });
  }

  onThumbClick(thumb) {
    // Update active thumb style
    this.thumbs.forEach((t) => {
      t.classList.remove('border-current');
      t.classList.add('border-transparent');
    });
    thumb.classList.add('border-current');
    thumb.classList.remove('border-transparent');

    // Swap main image
    const thumbImg = thumb.querySelector('img');
    if (this.mainImage && thumbImg) {
      // Get the high-res version from the thumb's src pattern
      const thumbSrc = thumbImg.src;
      const highResSrc = thumbSrc.replace(/width=\d+/, 'width=1200');
      this.mainImage.src = highResSrc;
      this.mainImage.srcset = '';
    }
  }
}

customElements.define('media-gallery', MediaGallery);
